import { layoutApplyButtonProperties } from './layoutApplyButtonProperties';
import { layoutCenterSPL } from './layoutCenterSPL';
import { layoutUpperCaseSPL } from './layoutUpperCaseSPL';
import type { App } from '../../../app/App';
import { layoutUserAvatarSPL } from './insertUserAvatarSPL';
import { layoutDynamicPropsOnResizeSPL } from './layoutDynamicPropsOnResizeSPL';
import { layoutCurvedTextSPL } from './layoutCurvedTextSPL';
import { layoutRotateSPL } from './layoutRotateSPL';
import { layoutColorTagsSPL } from './layoutColorTagsSPL';
import { LayoutText } from '../populateLayouts/LayoutText';
import { layoutApplyLayoutProps } from './layoutApplyLayoutProps';
import { layoutPropsSPL } from './layoutPropsSPL';
import { layoutShineSPL } from './layoutShineSPL';
import { layoutLocaSkinSPL } from './layoutLocaSkinSPL';
import { variableSPL } from './variableSPL';
import { replaceTextSPL } from './replaceTextSPL';
import { layoutApplyDefaultSkin } from './layoutApplyDefaultSkin';
import { insertAvatarSPL } from './insertAvatarSPL';
import { createVariableTextProcessor } from './textVariables';

export function addLayoutPostProcessors(app: App): void {
  layoutUpperCaseSPL();
  layoutApplyButtonProperties();
  layoutUserAvatarSPL(app);
  layoutPropsSPL();
  layoutDynamicPropsOnResizeSPL();
  layoutCurvedTextSPL();
  layoutRotateSPL();
  layoutColorTagsSPL();
  layoutApplyLayoutProps();
  layoutShineSPL();
  layoutLocaSkinSPL(() => app.stateController.getLanguage() ?? 'en_US');
  LayoutText.textProcessors.push(createVariableTextProcessor(app.utils.variableBank));
  variableSPL(app.utils.variableBank);
  replaceTextSPL();
  layoutApplyDefaultSkin();
  insertAvatarSPL(app);
  layoutCenterSPL();
}
